import { render, staticRenderFns } from "./ImportTableOfferBeneficiary.vue?vue&type=template&id=1ef23bc8&"
import script from "./ImportTableOfferBeneficiary.vue?vue&type=script&lang=js&"
export * from "./ImportTableOfferBeneficiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports